import { safeLocalStorage } from "@/lib/storage";
import { managedPrRef } from "./managedPrDisplay";

/**
 * Header chrome the session skeleton restores so the title and PR pill
 * keep the same footprint SessionHeader will paint.
 */

/** Undefined when PRs are not hydrated yet; null when the session has none. */
export function sessionHeaderPrLabel(
  prs: { repository: string; pr_number: number }[] | undefined,
): string | null | undefined {
  if (!Array.isArray(prs)) return undefined;
  if (prs.length === 0) return null;
  if (prs.length === 1) return managedPrRef(prs[0]);
  return "";
}

export interface CachedSessionHeaderChrome {
  title: string | null;
  /** Null when the session has no PR; "" for the multi-PR pill. */
  prLabel: string | null;
}

const HEADER_CHROME_KEY_PREFIX = "codesmith-session-header-chrome:";

function headerChromeKey(sessionId: string): string {
  return `${HEADER_CHROME_KEY_PREFIX}${sessionId}`;
}

export function cacheSessionHeaderChrome(
  sessionId: string,
  chrome: CachedSessionHeaderChrome,
) {
  safeLocalStorage.set(headerChromeKey(sessionId), JSON.stringify(chrome));
}

export function readCachedSessionHeaderChrome(
  sessionId: string,
): CachedSessionHeaderChrome | null {
  const raw = safeLocalStorage.get(headerChromeKey(sessionId));
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<CachedSessionHeaderChrome>;
    if (typeof parsed !== "object" || parsed == null) return null;
    const title = parsed.title === undefined ? null : parsed.title;
    const prLabel = parsed.prLabel === undefined ? null : parsed.prLabel;
    if (
      !(typeof title === "string" || title === null) ||
      !(typeof prLabel === "string" || prLabel === null)
    ) {
      return null;
    }
    return { title, prLabel };
  } catch {
    return null;
  }
}
